export type LocuslyEventType =
  | 'page_view'
  | 'lead_submitted'
  | 'rsvp_submitted'
  | 'phone_click'
  | 'whatsapp_click'
  | 'cta_click'
  | 'directions_click';

export type LocuslyTracker = {
  track: (
    type: LocuslyEventType,
    metadata?: Record<string, string | number | boolean>,
  ) => void;
  sessionId: string;
};

declare global {
  interface Window {
    locusly?: LocuslyTracker;
  }
}

export function trackEvent(
  type: LocuslyEventType,
  metadata?: Record<string, string | number | boolean>,
): void {
  if (typeof window === 'undefined') return;
  window.locusly?.track(type, metadata);
}
